/* AMBITION — Glücksrad im Warenkorb
   Aparece uma vez, quando um artigo é adicionado e o carrinho abre.
   1.ª volta: resultado "first" · 2.ª volta: resultado "second" (definições do tema).
   Ganhar → popup do Gutschein (sem fechar) → "einlösen" aplica o código de desconto
   ao carrinho (Shopify Ajax API) e o carrinho volta a renderizar com os preços riscados.
   O código tem de existir em Shopify → Rabatte. */
(function () {
  'use strict';
  var root = document.querySelector('[data-lum-wheel]');
  var cfgEl = document.querySelector('[data-lum-wheel-config]');
  if (!root || !cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.code) return;

  var KEY = 'lum_wheel_' + String(cfg.code).toUpperCase();
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  var state = load();

  /* ---- Preco na LP: com o Rabatt aplicado no carrinho, a caixa de compra mostra o preco
     original riscado (vermelho) e o novo preco (verde), como no drawer. So na LP dos
     produtos do Gluecksrad e so enquanto o codigo estiver mesmo no carrinho. ---- */
  var lpOnly = (cfg.products || []).filter(Boolean);
  function lpMatches() {
    var path = String(location.pathname || '').toLowerCase();
    return lpOnly.some(function (h) { return h && path.indexOf('/products/' + h) !== -1; });
  }
  var lpPainted = '';
  function paintLp() {
    if (!lpMatches()) return;
    var box = document.querySelector('[data-lp-buybox]');
    if (!box) return;
    var now = box.querySelector('[data-lp-price-now]');
    var was = box.querySelector('[data-lp-price-was]');
    var saveEl = box.querySelector('[data-lp-price-save]');
    if (!now) return;
    function apply() {
      var txt = now.textContent.trim();
      if (!txt || txt === lpPainted) return;
      var m = txt.match(/(\d[\d.\s]*)([,.])(\d{2})/);
      if (!m) return;
      var whole = parseInt(m[1].replace(/\D/g, ''), 10) || 0;
      var val = whole + (parseInt(m[3], 10) || 0) / 100;
      var nv = Math.max(0, val - (Number(cfg.amount) || 0));
      if (nv >= val) return;
      var out = txt.replace(m[0], nv.toFixed(2).replace('.', m[2]));
      lpPainted = out;
      now.textContent = out;
      now.classList.add('lw-now');
      if (was) { was.textContent = txt; was.hidden = false; was.classList.add('lw-was'); }
      if (saveEl) saveEl.hidden = true;
    }
    apply();
    if (!box.dataset.lwLpHooked) {
      box.dataset.lwLpHooked = '1';
      // o lumera-lp.js reescreve o preco a cada mudanca de variante: pintamos outra vez logo a seguir
      box.addEventListener('change', function () { setTimeout(apply, 0); });
      window.addEventListener('lp:relayout', function () { setTimeout(apply, 0); });
    }
  }
  if (cfg.applied) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintLp); else paintLp();
  }

  // Já aplicado ou já resgatado: nunca mais aparece.
  if (cfg.applied) { state.redeemed = true; save(state); }
  if (state.redeemed) return;

  var wheel = root.querySelector('[data-lw-wheel]');
  var panels = { wheel: root.querySelector('[data-lw-panel="wheel"]'), gift: root.querySelector('[data-lw-panel="gift"]') };
  var msg = root.querySelector('[data-lw-msg]');
  var count = root.querySelector('[data-lw-count]');
  var btnLabel = root.querySelector('[data-lw-btn-label]');
  var spinBtns = root.querySelectorAll('[data-lw-spin]');
  var redeemBtn = root.querySelector('[data-lw-redeem]');
  var closeBtn = root.querySelector('[data-lw-close]');
  var retryBtn = root.querySelector('[data-lw-retry]');
  panels.lost = root.querySelector('[data-lw-panel="lost"]');

  /* ---------- geometria dos sectores (Liquid não tem sin/cos) ---------- */
  var C = 150, R = 140;
  function pt(deg, r) {
    var a = (deg - 90) * Math.PI / 180;
    return [C + r * Math.cos(a), C + r * Math.sin(a)];
  }
  root.querySelectorAll('[data-lw-seg]').forEach(function (g) {
    var a0 = parseFloat(g.dataset.lwA0), step = parseFloat(g.dataset.lwStep), a1 = a0 + step;
    var p0 = pt(a0, R), p1 = pt(a1, R);
    var large = step > 180 ? 1 : 0;
    g.querySelector('path').setAttribute('d',
      'M' + C + ' ' + C + ' L' + p0[0].toFixed(2) + ' ' + p0[1].toFixed(2) +
      ' A' + R + ' ' + R + ' 0 ' + large + ' 1 ' + p1[0].toFixed(2) + ' ' + p1[1].toFixed(2) + ' Z');
  });

  var segs = Array.prototype.map.call(root.querySelectorAll('[data-lw-seg]'), function (g) {
    return { val: String(parseInt(g.dataset.lwSeg, 10)), ac: parseFloat(g.dataset.lwAc), step: parseFloat(g.dataset.lwStep), el: g };
  });
  function segFor(val) {
    val = String(parseInt(val, 10));
    for (var i = 0; i < segs.length; i++) if (segs[i].val === val) return segs[i];
    return segs[0];
  }

  /* ---------- rodar ---------- */
  var rotation = 0, spinning = false, spins = 0;
  var plan = [cfg.first, cfg.second];
  var amountTxt = cfg.amount + ' €';

  function setSpinEnabled(on) { spinBtns.forEach(function (b) { b.disabled = !on; }); }

  function spin() {
    if (spinning || spins >= plan.length) return;
    prepSound();
    spinning = true; setSpinEnabled(false); msg.textContent = ''; msg.classList.remove('lw__msg--win');
    var target = segFor(plan[spins]);
    // desvio dentro do sector, longe da borda
    var jitter = (Math.random() - 0.5) * (target.step * 0.6);
    var wanted = ((360 - target.ac - jitter) % 360 + 360) % 360;
    var current = ((rotation % 360) + 360) % 360;
    var delta = (wanted - current + 360) % 360;
    rotation += 360 * 5 + delta;
    wheel.style.transform = 'rotate(' + rotation + 'deg)';
    spins += 1;

    var done = false;
    function finish() {
      if (done) return; done = true;
      wheel.removeEventListener('transitionend', finish);
      onResult(target.val);
    }
    wheel.addEventListener('transitionend', finish);
    setTimeout(finish, 5200); // rede de segurança
  }

  /* som de moedas no prémio — pré-carregado no 1.º clique (o browser já deixa tocar) */
  var coin = null, lose = null;
  var vol = Math.max(0, Math.min(1, (parseInt(cfg.volume, 10) || 35) / 100));
  function mk(src, v) {
    if (!src) return null;
    try { var a = new Audio(src); a.preload = 'auto'; a.volume = v; a.load(); return a; } catch (e) { return null; }
  }
  function prepSound() {
    if (!coin) coin = mk(cfg.sound, vol);
    if (!lose) lose = mk(cfg.soundLose, Math.min(1, vol * 0.8));
  }
  function play(a) {
    if (!a) return;
    try { a.currentTime = 0; var pl = a.play(); if (pl && pl.catch) pl.catch(function () {}); } catch (e) {}
  }
  function playSound() { play(coin); }
  function playLose() { play(lose); }

  function onResult(val) {
    spinning = false;
    var valTxt = val + ' €';
    var isWin = String(val) === String(cfg.amount);
    if (isWin) {
      playSound();
      msg.textContent = cfg.msgWon.replace('%s', valTxt);
      msg.classList.add('lw__msg--win');
      state.won = true; state.seen = true; save(state);
      if (cfg.giftStep) { setTimeout(showGift, 1300); return; }
      // sem passo de cupão: aplica logo e fecha
      setTimeout(redeem, 1400);
      return;
    }
    if (spins < plan.length) {
      playLose();
      msg.textContent = cfg.msgLost.replace('%s', valTxt);
      count.textContent = String(plan.length - spins);
      btnLabel.textContent = cfg.btnAgain;
      setSpinEnabled(true);
      if (closeBtn) closeBtn.hidden = true; // ja rodou: a 2.a volta e o premio, nao ha o que fechar
      if (panels.lost) setTimeout(showLost, 900);
    } else {
      // plano esgotado sem prémio (só se as definições assim o disserem)
      msg.textContent = cfg.msgLost.replace('%s', valTxt).split('.')[0] + '.';
      state.seen = true; state.done = true; save(state);
      setTimeout(hide, 1600);
    }
  }

  /* ---------- mostrar / esconder ---------- */
  var shown = false;
  /* popover="manual" → top layer, por cima do overlay do cart-drawer (que também usa popover) */
  /* O focus-trap do cart-drawer fecha o drawer a qualquer clique fora dele.
     Enquanto a roda esta aberta, pausamos o trap para o carrinho ficar aberto atras. */
  function trap(pause) {
    var d = drawer();
    if (!d) return;
    try {
      var t = d.focusTrap;
      if (t) { if (pause) { t.pause(); } else { t.unpause(); } }
    } catch (e) {}
  }
  /* O focus-trap do drawer chama hide() a qualquer clique cujo alvo esteja FORA do
     <cart-drawer> (mesmo em pausa). Por isso a roda e movida para DENTRO do drawer
     enquanto esta aberta — o top layer (popover) desenha-a por cima na mesma. */
  var hasPopover = typeof root.showPopover === 'function';
  function openRoot() {
    var d = drawer();
    if (hasPopover && d && drawerOpen()) { if (root.parentElement !== d) d.appendChild(root); }
    else if (root.parentElement !== document.body) { document.body.appendChild(root); }
    root.hidden = false;
    trap(true);
    if (hasPopover) { try { root.showPopover(); } catch (e) {} }
  }
  function panel(name) {
    ['wheel', 'lost', 'gift'].forEach(function (k) { if (panels[k]) panels[k].hidden = (k !== name); });
  }
  function showWheel() {
    if (shown) return; shown = true;
    panel('wheel'); openRoot();
    state.seen = true; save(state);
    count.textContent = String(plan.length - spins);
    if (closeBtn) closeBtn.hidden = spins > 0;
  }
  function showLost() { shown = true; panel('lost'); openRoot(); }
  function showGift() { shown = true; panel('gift'); openRoot(); }

  /* X: fecha sem rodar → sem desconto. Volta a aparecer UMA vez, passados N s,
     so para quem fechou (estado local), e so se a pagina ainda estiver aberta. */
  var reshowMs = Math.max(0, parseInt(cfg.reshow, 10) || 0) * 1000;
  function dismiss() {
    if (spinning) return;
    hide(); shown = false;
    state.closed = (state.closed || 0) + 1; save(state);
    if (state.closed === 1 && reshowMs > 0) {
      setTimeout(function () {
        if (state.won || state.redeemed || state.done || shown) return;
        armed = true; showWheel();
      }, reshowMs);
    }
  }
  if (closeBtn) closeBtn.addEventListener('click', dismiss);

  /* "Nochmal versuchen": volta a roda e roda logo (2.a volta = premio) */
  if (retryBtn) retryBtn.addEventListener('click', function () {
    panel('wheel'); openRoot();
    setTimeout(spin, 350);
  });
  function hide() {
    if (typeof root.hidePopover === 'function') { try { root.hidePopover(); } catch (e) {} }
    root.hidden = true;
    trap(false);
  }

  // sem fechar: nem Esc, nem clique fora
  root.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); } }, true);
  root.querySelector('.lw__backdrop').addEventListener('click', function (e) { e.stopPropagation(); });
  ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (t) {
    root.addEventListener(t, function (e) { e.stopPropagation(); }, false);
  });

  spinBtns.forEach(function (b) { b.addEventListener('click', spin); });

  /* ---------- aplicar o Gutschein ---------- */
  var rootUrl = (cfg.root || '/').replace(/\/?$/, '/');
  async function applyCode(code) {
    var ok = false;
    try {
      var r = await fetch(rootUrl + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      });
      var j = await r.json();
      ok = Array.isArray(j.discount_codes) && j.discount_codes.some(function (d) {
        return String(d.code).toUpperCase() === code.toUpperCase() && d.applicable;
      });
    } catch (e) { ok = false; }
    if (!ok) {
      // caminho clássico: cookie de desconto para o checkout
      try { await fetch(rootUrl + 'discount/' + encodeURIComponent(code) + '?redirect=%2Fcart', { credentials: 'same-origin' }); ok = true; } catch (e) {}
    }
    return ok;
  }

  var redeeming = false;
  async function redeem() {
    if (redeeming) return; redeeming = true;
    if (redeemBtn) redeemBtn.disabled = true;
    var ok = await applyCode(cfg.code);
    state.redeemed = true; save(state);
    hide();
    if (ok) paintLp();
    // o cart-drawer do tema volta a buscar a sua secção e mostra o preço riscado + total novo
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var dd = drawer();
    if (dd && !drawerOpen() && typeof dd.show === 'function') { setTimeout(function () { try { dd.show(); } catch (e) {} }, 400); }
    if (!ok && window.console) console.warn('[lum-wheel] Rabatt "' + cfg.code + '" konnte nicht angewendet werden – existiert er unter Rabatte?');
  }
  if (redeemBtn) redeemBtn.addEventListener('click', redeem);

  /* ---------- gatilho: artigo adicionado + carrinho aberto ---------- */
  var armed = false, armTimer = null;
  function arm() { armed = true; clearTimeout(armTimer); armTimer = setTimeout(function () { armed = false; }, 10000 + delay); }
  function drawer() { return document.querySelector('cart-drawer, #cart-drawer'); }
  function drawerOpen() { var d = drawer(); return !!(d && (d.open || d.hasAttribute('open'))); }

  function maybeShow() {
    if (shown) return;
    if (state.won && !state.redeemed) { showGift(); return; }
    if (state.done) return;
    if (state.closed) return; // fechou com o X: so o reshow (uma vez) a traz de volta
    if (!armed) return;
    showWheel();
  }

  // só para os produtos configurados (handles); lista vazia = todos
  var only = (cfg.products || []).filter(Boolean);
  function matches(items) {
    if (!only.length) return true;
    return (items || []).some(function (it) { return it && only.indexOf(String(it.handle || '').toLowerCase()) !== -1; });
  }
  document.addEventListener('variant:add', function (e) {
    var d = e.detail || {};
    if (!matches(d.items)) return;
    arm(); setTimeout(function () { if (drawerOpen()) later(); }, 700);
  });
  document.addEventListener('cart:change', function (e) {
    var d = e.detail || {};
    if (d.baseEvent !== 'variant:add') return;
    if (!matches(d.cart && d.cart.items)) return;
    arm(); setTimeout(function () { if (drawerOpen()) later(); }, 700);
  });
  var delay = Math.max(0, parseInt(cfg.delay, 10) || 0) * 1000;
  function later() { setTimeout(function () { if (drawerOpen()) maybeShow(); }, delay); }
  document.addEventListener('dialog:after-show', function (e) {
    var t = e.target;
    if (!t || !(t.matches && (t.matches('cart-drawer') || t.id === 'cart-drawer'))) return;
    later();
  });
})();
